export default "__VITE_ASSET__BCwCRxJN__"